import { render, staticRenderFns } from "./UserTitles.vue?vue&type=template&id=79e4852c&"
import script from "./UserTitles.vue?vue&type=script&lang=js&"
export * from "./UserTitles.vue?vue&type=script&lang=js&"
import style0 from "./UserTitles.vue?vue&type=style&index=0&id=79e4852c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports